import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useOverlay } from './Overlay';
import { TextSheet } from './TextSheet';
import { readRated, saveVerdict, writeRated } from '@/lib/training';

// Thumbs under Dr C's messages in a real chat (Gary, 17 Oct), for every signed-in user since 19 Oct: "they are
// the actual users, their feedback is valuable". Each rating lands in Leo's training results.

export function DrcRate({ id, text }: { id: string; text: string }) {
  const { id: chatId } = useParams();
  const { openSheet, closeSheet, toast } = useOverlay();
  const [rated, setRated] = useState<'tick' | 'cross' | undefined>(() => readRated()[id]);

  async function rate(verdict: 'tick' | 'cross', comment: string) {
    try {
      await saveVerdict({ target_type: 'practice', target_ref: id, target_text: text, verdict, comment: comment || undefined, context: { live: true, chat_id: chatId ?? null } });
      writeRated(id, verdict);
      setRated(verdict);
    } catch (e) {
      toast(e instanceof Error ? e.message : 'That did not save. Try again.');
    }
  }

  return (
    <div className="chats-train-judge chats-train-judge--live">
      {rated ? (
        <span className={rated === 'tick' ? 'chats-label chats-label--green' : 'chats-label chats-label--red'}>{rated === 'tick' ? '👍 Good' : '👎 Noted'}</span>
      ) : (
        <>
          <button type="button" className="chats-train-thumb" aria-label="Good reply from Leo" onClick={() => void rate('tick', '')}>👍</button>
          <button
            type="button"
            className="chats-train-thumb"
            aria-label="Not a good reply from Leo"
            onClick={() => openSheet(<TextSheet title="What was wrong with this reply?" placeholder="A few words: too long, wrong price, sounds like a robot..." onSend={async (why) => { await rate('cross', why); closeSheet(); }} />)}
          >👎</button>
        </>
      )}
    </div>
  );
}
